import { OSTYPE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: OSTYPE_MNG,
  callBackAction: 'osTypeCopy',
  params: {},
  okAction: 'copyOsType',
  toolbar: {},
  needFetchFillInfo: false,
  view: {
    labelPosition: 'right',
    labelWidth: '225px',
    content: [
      {
        $id: 'copyMultiOsTypeList',
        $type: 'sky-copy-multi-os-type',
        label: '操作系统限制内容复制项'
      }
    ]
  }
}
